import { InjectionToken } from '@angular/core';
import { LoggerParamsTransformer } from '@content-platform/web-angular-shared-util-logging';

export const REPORT_PARAM_TRANSFORMERS = new InjectionToken('report-param-transformers');

export abstract class ReportParamsTransformer extends LoggerParamsTransformer {}
